import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import ActivityService from "../../services/activities.service";

// **Async Thunks**
export const getActivity = createAsyncThunk(
  "activity/getActivity",
  async (item, thunkApi) => {
    try {
      const response = await ActivityService.getActivity(item);
      return response.data || []; 
    } catch (error) {
      return thunkApi.rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const addActivity = createAsyncThunk(
  "activity/addActivity",
  async (item, thunkAPI) => {
    try {
      const response = await ActivityService.addActivity(item);
      return response.data || response.data; 
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const editActivity = createAsyncThunk(
  "activity/editActivity",
  async (item, thunkAPI) => {
    try {
      const response = await ActivityService.editActivity(item);
      return response.data || response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const deleteActivity = createAsyncThunk(
  "activity/deleteActivity",
  async (id, thunkAPI) => {
    try {
      await ActivityService.deleteActivity(id);
      return id; // ✅ Return only the ID for state update
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

// **Initial State**
const initialState = {
  loading: false,
  error: "",
  activity: [],
};

// **Slice**
const activitySlice = createSlice({
  name: "activity",
  initialState,
  extraReducers: (builder) => {
    builder
      // **Handle Get Car Rental Package List**
      .addCase(getActivity.pending, (state) => {
        state.loading = true;
        state.error = "";
      })
      .addCase(getActivity.fulfilled, (state, action) => {
        state.loading = false;
        state.carrentalPackages = action.payload;
      })
      .addCase(getActivity.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // **Handle Add Car Rental Package**
      .addCase(addActivity.pending, (state) => {
        state.loading = true;
      })
      .addCase(addActivity.fulfilled, (state, action) => {
        state.loading = false;
        state.carrentalPackages.push(action.payload);
      })
      .addCase(addActivity.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // **Handle Edit Car Rental Package**
      .addCase(editActivity.pending, (state) => {
        state.loading = true;
      })
      .addCase(editActivity.fulfilled, (state, action) => {
        state.loading = false;
        const index = state.carrentalPackages.findIndex((p) => p._id === action.payload._id); // ✅ Handle `_id` correctly
        if (index !== -1) {
          state.carrentalPackages[index] = action.payload;
        }
      })
      .addCase(editActivity.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // **Handle Delete Car Rental Package**
      .addCase(deleteActivity.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteActivity.fulfilled, (state, action) => {
        state.loading = false;
        state.carrentalPackages = state.carrentalPackages.filter((p) => p._id !== action.payload); // ✅ Handle `_id`
      })
      .addCase(deleteActivity.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

// **Export Reducer**
export default activitySlice.reducer;
